import { InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { RyftApplePayConfig, RyftGooglePayConfig } from './models';

export const RYFT_PUBLIC_KEY = new InjectionToken<string>('RYFT_PUBLIC_KEY');

export const RYFT_GOOGLE_PAY_CONFIG = new InjectionToken<RyftGooglePayConfig | undefined>(
  'RYFT_GOOGLE_PAY_CONFIG',
);

export const RYFT_APPLE_PAY_CONFIG = new InjectionToken<RyftApplePayConfig | undefined>('RYFT_APPLE_PAY_CONFIG');

export interface RyftProviderConfig {
  publicKey: string;
  googlePay?: RyftGooglePayConfig;
  applePay?: RyftApplePayConfig;
}

export const provideRyft = (config: RyftProviderConfig) => {
  return makeEnvironmentProviders([
    {
      provide: RYFT_PUBLIC_KEY,
      useValue: config.publicKey,
    },
    {
      provide: RYFT_GOOGLE_PAY_CONFIG,
      useValue: config.googlePay,
    },
    {
      provide: RYFT_APPLE_PAY_CONFIG,
      useValue: config.applePay,
    },
  ]);
};
